export default __webpack_public_path__ + "static/featuresListItem8-866f7547de1f6b40aa225715ae9f7748.svg";